module.exports = __webpack_public_path__ + "img/02.fef389e0.jpg";